import willBuildIcon from "@src/assets/CN/images/willBuild.png";
import styles from "./index.module.less";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { isMobile } from "react-device-detect";

export default function WillBuild() {
  return (
    <div className={`${isMobile ? styles.MobileBuild : styles.PCBuild} flex flex-col items-center`}>
      <img src={willBuildIcon} className={styles.buildIcon} />
      <span className={styles.buildTips}>网站升级中，敬请期待</span>
    </div>
  );
}
